import { collection, getDocs, db } from "../../../services/firestoreApi";
import { useEffect, useState } from "react";
import { registrarCanje } from "../../../services/beneficiosService";
import CustomSpinner from "../../general/CustomSpinner";
import UserContext from "../../user/UserContext";
import { useContext } from "react";

const RegistrarCanje = () => {
    const [aliados, setAliados] = useState([])
    const [aliadoId, setAliadoId] = useState("")
    const [ahorro, setAhorro] = useState("")
    const [mensaje, setMensaje] = useState("")
    const { admin, loading, setLoading } = useContext(UserContext)

    useEffect(() => {
        const cargarAliados = async () => {
            const snapshot = await getDocs(collection(db, "beneficios"))
            setAliados(snapshot.docs.map(item => ({ id: item.id, ...item.data() })))
        }
        cargarAliados()
    }, [])

    const guardar = async event => {
        event.preventDefault()
        const aliado = aliados.find(item => item.id === aliadoId)
        if (!aliado) {
            setMensaje("Selecciona un negocio aliado.")
            return
        }

        setLoading(true)
        try {
            await registrarCanje({ aliado, ahorro, registradoPor: admin?.user?.uid })
            setAliadoId("")
            setAhorro("")
            setMensaje("Beneficio usado registrado correctamente.")
        } catch (error) {
            setMensaje("No se pudo registrar el beneficio usado.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <CustomSpinner />}
            <div className="container text-start my-5 admin-module admin-module-affiliates">

                <div className="admin-canje-heading">
                    <div><p className="admin-kicker">OPERACIÓN DE LA RED</p><h2>Registrar beneficio usado</h2><p>Registra cuando una familia utilice su tarjeta con un negocio aliado.</p></div>
                </div>
                <form onSubmit={guardar} className="admin-canje-form">
                    <label>Negocio aliado<select value={aliadoId} onChange={event => setAliadoId(event.target.value)}><option value="">Selecciona un negocio</option>{aliados.map(item => <option key={item.id} value={item.id}>{item.title}</option>)}</select></label>
                    <label>Ahorro estimado (MXN)<input type="number" min="0" step="0.01" value={ahorro} onChange={event => setAhorro(event.target.value)} placeholder="Ej. 150" /></label>
                    <button type="submit">Registrar beneficio usado</button>
                </form>
                {mensaje && <p className="admin-canje-message">{mensaje}</p>}
            </div>
        </>
    )

}

export default RegistrarCanje